module.exports = __webpack_public_path__ + "img/9788981171223.baa8bb86.jpg";